module.exports = __webpack_public_path__ + "img/CM-KT-CA-CJDR-Established.30d8aade.jpeg";